module.exports = __webpack_public_path__ + "img/pl.563a0859.svg";